/*globals $ */

import Swiper, { Navigation, Pagination } from "swiper";

import Hero from "./Hero";
import AnimationSection from "./AnimationSection";

class PageHome {
  constructor(mainApp) {
    this.mainApp = mainApp;
    this.hero = new Hero(this);
    this.animation = new AnimationSection(this.mainApp);
    this.scrollTop = 0;

    $(".EfText").each((i, e) => {
      let $el = $(e);
      let lines = $el[0].innerHTML.split("<br>");
      for (let i = 0; i < lines.length; i++) {
        lines[i] = this.wrapCharSpan(lines[i]);
      }
      $el[0].innerHTML = lines.join("<br>");
    });

    new Swiper(".swiper", {
      modules: [Navigation, Pagination],
      slidesPerView: 1, //2,
      spaceBetween: 28,
      loop: true,
      loopAdditionalSlides: 1,
      navigation: {
        prevEl: ".BtnSwiperNav--prev",
        nextEl: ".BtnSwiperNav--next",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
      },
      breakpoints: {
        // when window width is >= 320px
        800: {
          slidesPerView: 2, // ,
          // spaceBetween: 28
        },
      },
    });

    this.onLoadCompleteHero();
  }
  onLoadCompleteHero() {
    $(".HeroTitle").addClass("HeroTitle--fadein");
    setTimeout(() => {
      $(".HeroNav").addClass("HeroNav--fadein");
    }, 400);

    this.animation.loadImages();
    let hash = window.location.hash;
    if (hash.length > 2) {
      let target = hash.slice(1);
      if (target == "windguardian") {
        this.mainApp.scrollPage($(".Section--product").offset()["top"]);
      } else if (target == "windforesight") {
        this.mainApp.scrollPage($(".Section--system").offset()["top"]);
      }
    }

    /*
    this.animateUpdate = setInterval(() => {
      this.animation.onWindowScroll(this.scrollTop);
    }, 1000 / 30);
    */
  }
  wrapCharSpan(str) {
    return [...str].map((char) => `<span>${char}</span>`).join("");
  }

  onWindowScroll(scrollTop) {
    this.scrollTop = scrollTop;

    let isInvertHeader = false;
    if (scrollTop < $(".Hero").height() - 100) {
      isInvertHeader = true;
    }
    if (
      scrollTop > $(".Section--product").offset()["top"] - 70 &&
      scrollTop <
        $(".Section--product").offset()["top"] +
          $("#Section--product__inner").height()
    ) {
      isInvertHeader = true;
    }
    if (
      scrollTop > $(".Section--system").offset()["top"] - 70 &&
      scrollTop <
        $(".Section--system").offset()["top"] + $(".Section--system").height()
    ) {
      isInvertHeader = true;
    }

    if (isInvertHeader) {
      $(".Header").addClass("Header--invert");
    } else {
      $(".Header").removeClass("Header--invert");
    }

    this.animation.onWindowScroll(this.scrollTop);
  }

  onWindowResize() {
    this.hero.onWindowResize();
    this.animation.onWindowResize();
    $("#ProductHero__ground").width(document.documentElement.clientWidth);
    $(".CommonWidth__bg").width(document.documentElement.clientWidth);
  }

  destroy() {
    this.hero.destroy();
    this.animation.destroy();
    $(".Header").removeClass("Header--invert");
  }
}

export default PageHome;
